import { useNavigate } from "react-router-dom";
import { Container, Card, Table, ButtonGroup, Button, Col, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faEye, faHourglass, faCheck, faClose, faMinus, faReply } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import { ThreeDots } from 'react-loader-spinner';
import { getMedicalClaimLists, getMedicalClaimListsCount, updateCurrentPage } from "../../3.Store/MedicalClaimSlice";
import Pagination from "../../2.Commons/Pagination";

const MedicalClaimList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const employee = JSON.parse(localStorage.getItem("current_user"));
  const userId = employee?.id;
  const lists = useSelector(state => state.MedicalClaimSlice.medicalClaimLists);
  const currentPage = useSelector(state => state.MedicalClaimSlice.currentPage);
  const totalPages = useSelector(state => state.MedicalClaimSlice.totalPages);
  const role = JSON.parse(localStorage.getItem("roles"));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    // if (!role || !role.includes("HR-M-BENEFIT")) {  // Check required role 
    //   localStorage.clear(); 
    //   window.location.href = "/Login"; 
    // }

    if(userId) {
      setLoading(true);
      dispatch(getMedicalClaimLists({id:userId, page:currentPage}))
      .then(() => {
        return dispatch(getMedicalClaimListsCount({ id: userId }));
      })
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
    }
  }, [userId])

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleBtnBack = () => {
    navigate("/");
  };

  const handleBtnAdd = () => {
    navigate("/MedicalClaimForm");
  };

  const handleClickView = (id) => {
    navigate(`/MedicalClaimForm/${id}`);
  };

  const handleClickEdit = () => {};

  const handlePreviousPage = () => {
    setLoading(true);
    if (currentPage > 1) {
      dispatch(updateCurrentPage(currentPage - 1));
      dispatch(getMedicalClaimLists({id:userId, page:currentPage - 1}))
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
    }
  };

  const handleNextPage = () => {
    setLoading(true);
    if (currentPage < totalPages) {
      dispatch(updateCurrentPage(currentPage + 1));
      dispatch(getMedicalClaimLists({id:userId, page:currentPage + 1}))
      .then(() => {
          setLoading(false);
      })
      .catch(() => {
          setLoading(false);
      });
    }
  };

  const handlePageChange = (page) => {
    setLoading(true);
    dispatch(updateCurrentPage(page));
    if (currentPage <= totalPages) {
      dispatch(getMedicalClaimLists({id:userId, page}))
      .then(() => {
          setLoading(false);
      })
      .catch(() => {
          setLoading(false);
      });
    }
  };

  return (
    <div className="ContainerContent2">
      {loading && (
        <ThreeDots
        visible={loading}
        height="80"
        width="80"
        color="#4fa94d"
        radius="9"
        ariaLabel="three-dots-loading"
        wrapperStyle={{
          position: 'fixed',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: '9999',
        }}
        />
      )}
      <Card className="CardContent">
        <h1 className="TitleHeader">Medical Claims</h1>
        <h1 className="MiniTitleHeader">List</h1>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <div style={{ overflowX: 'auto' }}>
          <Table className="my-fixed-table" style={{ fontSize: "14px", cursor: "pointer" }}>
            <thead>
              <tr>
                {isMobile ? (
                  <>
                    <th style={{ width: "60px" }}>Medical Claims</th>
                    <th style={{ width: "5px" }} className="text-center align-middle">Status</th>
                    <th style={{ width: "15px" }} className="text-center align-middle">
                      <FontAwesomeIcon icon={faEye} />
                    </th>
                    <th style={{ width: "10px" }} className="text-center align-middle">
                      <FontAwesomeIcon icon={faPenToSquare} />
                    </th>
                  </>
                ) : (
                  <>
                    <th style={{ width: "20px" }}>No</th>
                    <th style={{ width: "50px" }}>Date Applied</th>
                    <th style={{ width: "50px" }}>Receipt No.</th>
                    <th style={{ width: "100px" }}>Practitioner</th>
                    <th style={{ width: "30px" }}>Claim (RM)</th>
                    <th style={{ width: "15px" }} className="text-center align-middle">Status</th>
                    <th style={{ width: "15px" }} className="text-center align-middle">
                      <FontAwesomeIcon icon={faEye} title="Review"/>
                    </th>
                    <th style={{ width: "10px" }} className="text-center align-middle">
                      <FontAwesomeIcon icon={faPenToSquare} title="Action"/>
                    </th>
                  </>
                )}

                {/* <th style={{ width: "20px" }}>No</th>
                <th style={{ width: "50px" }}>Date Applied</th>
                <th style={{ width: "50px" }}>Receipt No.</th>
                <th style={{ width: "100px" }}>Practitioner</th>
                <th style={{ width: "30px" }}>Claim (RM)</th>
                <th style={{ width: "15px" }} className="text-center align-middle">Status</th>
                <th style={{ width: "15px" }} className="text-center align-middle">Review</th>
                <th style={{ width: "10px" }} className="text-center align-middle">
                  <FontAwesomeIcon icon={faPenToSquare} />
                </th> */}
              </tr>
            </thead>
            {!loading && (
              <tbody>
                {lists.length > 0 ? (
                  lists.map((employee, index) => (
                  <tr onClick={() => handleClickView(employee.id)} key={employee.id} style={{ cursor: "pointer" }}>
                    {isMobile ? (
                      <>
                        <td onClick={(e) => {handleClickView(employee.id); e.stopPropagation();}}>
                          <strong>Amount: RM{employee.amount}</strong>
                          <br/>
                          <strong>Date: {moment(employee.created).format("YYYY-MM-DD")}</strong>
                          <br/>
                          <strong>Practitioner: </strong>{employee.receipt_reference}
                          <br/>
                          <strong>Receipt No: </strong>{employee.receipt_no}
                        </td>
                        <td className="text-center align-middle">
                          {employee.status.description === "PENDING" && (
                            <FontAwesomeIcon icon={faHourglass} color="#FFC107" />
                          )}
                          {employee.status.description === "APPROVED-HR" && (
                            <FontAwesomeIcon icon={faCheck} color="#28A744" />
                          )}
                          {employee.status.description === "APPROVED-S" && (
                            <FontAwesomeIcon icon={faCheck} color="#28A744" />
                          )}
                          {employee.status.description === "REJECTED-HR" && (
                            <FontAwesomeIcon icon={faClose} color="#DC3545" />
                          )}
                          {employee.status.description === "REJECTED-S" && (
                            <FontAwesomeIcon icon={faClose} color="#DC3545" />
                          )}
                          {employee.status.description === "DELETED" && (
                            <FontAwesomeIcon icon={faMinus} color="#FFC107" />
                          )}
                          {employee.status.description === "WITHDRAWN" && (
                            <FontAwesomeIcon icon={faReply} color="#28A744" />
                          )}
                        </td>
                        <td className="text-center align-middle">
                          {employee.hr_reviewed == false ? (
                            <FontAwesomeIcon icon={faClose} color="#DC3545" />
                          ) : (
                            <FontAwesomeIcon icon={faCheck} color="#28A744" />
                          )}
                        </td>
                        <td className="text-center align-middle">
                          <FontAwesomeIcon icon={faPenToSquare} style={{ color: "blue" }} />
                        </td>
                      </>
                    ) : (
                      <>
                        <td>{index + 1}</td>
                        <td>{moment(employee.modified).format("YYYY-MM-DD")}</td>
                        <td>{employee.receipt_reference}</td>
                        <td>{employee.receipt_no}</td>
                        <td>{employee.amount}</td>
                        <td className="text-center align-middle">
                          {employee.status.description === "PENDING" && (
                            <FontAwesomeIcon icon={faHourglass} color="#FFC107" />
                          )}
                          {employee.status.description === "APPROVED-HR" && (
                            <FontAwesomeIcon icon={faCheck} color="#28A744" />
                          )}
                          {employee.status.description === "APPROVED-S" && (
                            <FontAwesomeIcon icon={faCheck} color="#28A744" />
                          )}
                          {employee.status.description === "REJECTED-HR" && (
                            <FontAwesomeIcon icon={faClose} color="#DC3545" />
                          )}
                          {employee.status.description === "REJECTED-S" && (
                            <FontAwesomeIcon icon={faClose} color="#DC3545" />
                          )}
                          {employee.status.description === "DELETED" && (
                            <FontAwesomeIcon icon={faMinus} color="#FFC107" />
                          )}
                          {employee.status.description === "WITHDRAWN" && (
                            <FontAwesomeIcon icon={faReply} color="#28A744" />
                          )}
                        </td>
                        <td className="text-center align-middle">
                          {employee.hr_reviewed == false ? (
                            <FontAwesomeIcon icon={faClose} color="#DC3545" />
                          ) : (
                            <FontAwesomeIcon icon={faCheck} color="#28A744" />
                          )}
                        </td>
                        <td className="text-center align-middle">
                          <FontAwesomeIcon icon={faPenToSquare} style={{ color: "blue" }}/>
                        </td>
                      </>
                    )}
                  </tr>
                  ))
                  ) : (
                  <tr>
                    <td colSpan={isMobile ? "4" : "8"}>No results found</td>
                  </tr>
                )}
              </tbody>
            )}
          </Table>
        </div>

        <div className="legend-pagination-row">
          <div className="legend-container">
            <div className="legend-row">
              <span className="legend-item2" style={{ color: "black" , fontSize: "14px" }}>
                <FontAwesomeIcon icon={faHourglass} color="#FFC107" />
                &nbsp;Pending
                &ensp;&ensp;&ensp;&ensp;&ensp;
                <FontAwesomeIcon icon={faCheck} color="#28A744" />
                &nbsp;Approved/Reviewed
                &ensp;&ensp;&ensp;&ensp;&ensp;
                <FontAwesomeIcon icon={faClose} color="#DC3545" />
                &nbsp;Rejected/Not Reviewed
                &ensp;&ensp;&ensp;&ensp;&ensp;
                <FontAwesomeIcon icon={faMinus} color="#FFC107" />
                &nbsp;Deleted
              </span>
            </div>
          </div>

          <div
            style={{
              marginLeft: "auto",
              marginTop: isMobile ? "10px" : "0px"
            }}
          >
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              handlePreviousPage={handlePreviousPage}
              handleNextPage={handleNextPage}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>

        {/* <Col style={{ marginLeft: "auto" }}>
          <Form.Label className="FormLabel">{`${currentPage} of ${totalPages}`}</Form.Label> &ensp;
          {currentPage > 1 ? (
            <Form.Label className="FormLabel" onClick={handlePreviousPage} style={{ cursor: "pointer" }}>
              <FontAwesomeIcon icon={faChevronLeft} style={{ color: "#ffffff" }} />
            </Form.Label>
          ) : (
            <Form.Label className="FormLabel" style={{ color: "#cccccc" }}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </Form.Label>
          )}
          &ensp;
          {currentPage < totalPages ? (
            <Form.Label className="FormLabel" onClick={handleNextPage} style={{ cursor: "pointer" }}>
              <FontAwesomeIcon icon={faChevronRight} style={{ color: "#ffffff" }} />
            </Form.Label>
          ) : (
            <Form.Label className="FormLabel" style={{ color: "#cccccc" }}>
              <FontAwesomeIcon icon={faChevronRight} />
            </Form.Label>
          )}
        </Col> */}

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
            Back
            </Button>
          </ButtonGroup>
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnAdd}>
              Add
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </div>
  );
};
export default MedicalClaimList;
